<template>
  <div class="role-manage">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="msForm" ref="msForm" :model="msForm" label-position="right" @submit.native.prevent>
      <div class="self-adapting-condition">
        <el-form-item  label="角色名称：">
          <el-input class="zwx-input" v-model="msForm.roleNameLike" placeholder="请输入" @keyup.enter.native="search()"
                    clearable/>
        </el-form-item>
        <div class="condition-button-row">
          <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search()">查询
          </el-button>
          <el-button class="zwx-button zwx-button-icontext-28" icon="el-icon-plus" @click="add()">添加
          </el-button>
        </div>
      </div>
    </el-form>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table"  height=" calc(100vh - 152px)" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="roleName" label="角色名称" :width="$system.calWidth(dataList, 'roleName', '角色名称')"
                       header-align="left" align="left"></el-table-column>
      <el-table-column prop="roleCode" label="角色编码" :width="$system.calWidth(dataList, 'roleCode', '角色编码')"
                       header-align="center" align="center"></el-table-column>
      <el-table-column prop="roleDesc" label="角色描述"
                       :width="$system.calWidth(dataList, 'roleDesc', '角色描述', undefined, 330)" header-align="left"
                       align="left"></el-table-column>
      <el-table-column fixed="right" label="操作"
                       :min-width="$system.calMinWidth({ wordNum: 14, arrowNum: 3, btnNum: 6 })" header-align="left"
                       align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="menu(scope.row)" v-if="scope.row.ifCreateUser">菜单分配
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="user(scope.row)">人员分配
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="edit(scope.row)" v-if="scope.row.ifCreateUser">编辑
          </el-button>
          <el-button class="zwx-button zwx-button-text-26"
                     :style="scope.row.ifEnable ? 'color: #e72b00 !important;' : ''" type="text"
                     @click="$system.msgbox(scope.row, '提示', scope.row.ifEnable ? '确定要停用吗？' : '确定要启用吗？', '确定', '取消', enable)"
                     v-if="scope.row.ifCreateUser">{{
              scope.row.ifEnable ? '停用' : '启用'
            }}
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="danger"
                     @click="$system.msgbox(scope.row, '提示', '确定要删除吗？', '确定', '取消', deletion)"
                     v-if="scope.row.ifCreateUser && !scope.row.ifEnable">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'RoleManage',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      msForm: {
        roleNameLike: '',
      },
      dataList: [],
    }
  },
  created() {
  },
  mounted() {
    this.search()
  },
  activated() {
    if (this.$route.params.fresh) this.search()
  },
  computed: {},
  methods: {
    search() {
      this.$emit('loading', true)
      let data = {
        roleNameLike: this.msForm.roleNameLike,
      }
      this.$system.get(this.api + '/systematic/getRoleList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.roleList
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    enable(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid, ifEnable: !row.ifEnable}
      this.$system.post(this.api + '/systematic/modifyRoleState-1', data, true, true, this.enableSuccess, this.error)
    },
    enableSuccess(data) {
      if (data.type === '00') {
        this.search()
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    deletion(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid}
      this.$system.post(this.api + '/systematic/deleteRole-1', data, true, true, this.deletionSuccess, this.error)
    },
    deletionSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.search()
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    user(row) {
      this.$router.push({name: 'RoleUser', params: {rid: row.rid, roleName: row.roleName}})
    },
    add() {
      this.$router.push({name: 'RoleEdit', params: {}})
    },
    edit(row) {
      this.$router.push({name: 'RoleEdit', params: {rid: row.rid}})
    },
    menu(row) {
      this.$router.push({name: 'RoleMenu', params: {rid: row.rid, roleName: row.roleName}})
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
